import { Box, Button, IconButton, useTheme, useMediaQuery, TextField, Snackbar} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { Controller, useForm } from 'react-hook-form';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import { trpc } from 'src/utils/trpc';
import { useState } from 'react';
import Alert from '@mui/material/Alert';


interface Props {
  open: boolean;
  handleClose: () => void;
  vehicle: any;
}

const SalesLeadDialog: React.FC<Props> = ({
  open,
  handleClose,
  vehicle
}) => {
    const theme = useTheme();
    const smBelow = useMediaQuery(theme.breakpoints.down('sm'));

    const [showSuccesSnack, setSuccessSnack] = useState(false);

    const {
      handleSubmit,
      control,
      formState: { errors },
      reset,
    } = useForm({
      defaultValues: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
      },
    });

    const saveMutation = trpc.vehicles.sendLeadEmail.useMutation({
      onError(error) {
        console.error(error);
      },
      onSuccess() {
        setSuccessSnack(true);

        setTimeout(function () {
          handleClose();
        }, 1000);
      },
    });

    const onSubmit = (data: any) => {
      reset();
      saveMutation.mutate({
        vehicle_id: vehicle.id,
        contact_email: data.email,
        contact_phone: data.phone,
        contact_first_name: data.first_name,
        contact_last_name: data.last_name,
      });
    };

    return (
      <Dialog open={open} onClose={() => handleClose()} fullScreen={smBelow}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>
            Check Availability
            <IconButton
              aria-label="close"
              onClick={() => handleClose()}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ minWidth: '600px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                flexDirection: 'column',
                p: 2,
              }}
            >
              <Box sx={{ width: '80%', m: 1 }}>
                <FormControl fullWidth>
                  <InputLabel error={Boolean(errors.first_name)}>
                    First Name
                  </InputLabel>
                  <Controller
                    name="first_name"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <OutlinedInput
                        value={value}
                        label="First Name"
                        onChange={onChange}
                        id="stepper-linear-account-contact_phone"
                        error={Boolean(errors.first_name)}
                      />
                    )}
                  />
                  {errors.first_name && (
                    <FormHelperText
                      sx={{ color: 'error.main' }}
                      id="stepper-linear-account-contact_phone-helper"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
              <Box sx={{ width: '80%', m: 1 }}>
                <FormControl fullWidth>
                  <InputLabel error={Boolean(errors.last_name)}>
                    Last Name
                  </InputLabel>
                  <Controller
                    name="last_name"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <OutlinedInput
                        value={value}
                        label="Last Name"
                        onChange={onChange}
                        id="stepper-linear-account-contact_phone"
                        error={Boolean(errors.last_name)}
                      />
                    )}
                  />
                  {errors.last_name && (
                    <FormHelperText
                      sx={{ color: 'error.main' }}
                      id="stepper-linear-account-contact_phone-helper"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
              <Box sx={{ width: '80%', m: 1 }}>
                <FormControl fullWidth>
                  <InputLabel error={Boolean(errors.email)}>Email</InputLabel>
                  <Controller
                    name="email"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <OutlinedInput
                        value={value}
                        label="Email"
                        onChange={onChange}
                        id="stepper-linear-account-contact_phone"
                        error={Boolean(errors.email)}
                      />
                    )}
                  />
                  {errors.email && (
                    <FormHelperText
                      sx={{ color: 'error.main' }}
                      id="stepper-linear-account-contact_phone-helper"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
              <Box sx={{ width: '80%', m: 1 }}>
                <FormControl fullWidth>
                  <InputLabel error={Boolean(errors.phone)}>Phone</InputLabel>
                  <Controller
                    name="phone"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <OutlinedInput
                        value={value}
                        label="Phone Number"
                        onChange={onChange}
                        id="stepper-linear-account-contact_phone"
                        error={Boolean(errors.phone)}
                      />
                    )}
                  />
                  {errors.phone && (
                    <FormHelperText
                      sx={{ color: 'error.main' }}
                      id="stepper-linear-account-contact_phone-helper"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
              <Box sx={{ width: '80%', m: 1 }}>
                <FormControl fullWidth>
                  <Controller
                    name="message"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <TextField
                        value={value}
                        multiline
                        label="Message"
                        onChange={onChange}
                        id="stepper-linear-account-contact_phone"
                        error={Boolean(errors.message)}
                      />
                    )}
                  />
                  {errors.message && (
                    <FormHelperText
                      sx={{ color: 'error.main' }}
                      id="stepper-linear-account-contact_phone-helper"
                    >
                      This field is required
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Box>

            <Snackbar
              open={showSuccesSnack}
              onClose={() => setSuccessSnack(false)}
              autoHideDuration={3000}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert
                variant="filled"
                elevation={3}
                onClose={() => setSuccessSnack(false)}
                severity="success"
              >
                Dealership has been notified!
              </Alert>
            </Snackbar>
          </DialogContent>
          <DialogActions>
            <>
              <Button
                variant="contained"
                color="error"
                onClick={handleClose}
                sx={{
                  backgroundColor: '#FF4C51 !important',
                  '&:hover': {
                    backgroundColor: '#FF4C51 !important',
                    color: '#FFF',
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: '#56ca00 !important',
                  '&:hover': {
                    backgroundColor: '#56ca00 !important',
                    color: '#FFF',
                  },
                }}
              >
                Submit
              </Button>
            </>
          </DialogActions>
        </form>
      </Dialog>
    );
};


export default SalesLeadDialog
